import React from "react";
import { connect } from "react-redux";
import { clearValidation, inputValidation, updateCustomer, setLoader } from "../../actions";
import requireAuth from "../requireAuth";
import AccountNav from "../AccountNav";
import { Field, reduxForm } from "redux-form";
import history from "../../history";

class AccountAddAddressPage extends React.Component {
  constructor(props) {
    super(props);

    this.addressInput = React.createRef();

    this.state = {
      show_address_fields: false,
      regions: [
        {
          id: "569",
          code: "ACT",
          name: "Australian Capital Territory",
        },
        {
          id: "570",
          code: "NSW",
          name: "New South Wales",
        },
        {
          id: "576",
          code: "NT",
          name: "Northern Territory",
        },
        {
          id: "572",
          code: "QLD",
          name: "Queensland",
        },
        {
          id: "573",
          code: "SA",
          name: "South Australia",
        },
        {
          id: "574",
          code: "TAS",
          name: "Tasmania",
        },
        {
          id: "571",
          code: "VIC",
          name: "Victoria",
        },
        {
          id: "575",
          code: "WA",
          name: "Western Australia",
        },
      ],
    };
  }

  componentDidMount = () => {
    // Pre-fill mobile and name from localStorage
    const mobile = localStorage.mobile || '';
    const firstName = localStorage.first_name || '';
    const lastName = localStorage.last_name || '';
    if (mobile) {
      this.props.change("mobile", mobile);
    }
    if (firstName || lastName) {
      this.props.change("fullname", `${firstName} ${lastName}`.trim());
    }

    var autocomplete = new window.google.maps.places.Autocomplete(
      document.getElementById("google-places-input")
    );
    autocomplete.addListener("place_changed", () => {
      var place = autocomplete.getPlace();
      console.log(place);

      if (place.address_components != undefined) {
        const address = {
          street_address: "",
          suburb: "",
          state: "",
          country: "",
          postcode: "",
        };

        // set country
        place.address_components.forEach(function (value) {
          if (value.types.includes("country")) {
            address.country = value.short_name;
          }
        });

        // set street address
        var street_address = "";
        place.address_components.forEach(function (value) {
          if (value.types.includes("street_number")) {
            street_address += value.long_name;
          }
        });
        street_address += " ";
        place.address_components.forEach(function (value) {
          if (value.types.includes("route")) {
            street_address += value.long_name;
          }
        });
        address.street_address = street_address;

        // set city/suburb - check multiple possible types with priority
        // Priority: locality > postal_town > sublocality_level_1 > sublocality > administrative_area_level_2
        place.address_components.forEach(function (value) {
          // Fallback: administrative_area_level_2 (county/district)
          if (value.types.includes("administrative_area_level_2") && !address.suburb) {
            address.suburb = value.long_name;
          }
        });
        place.address_components.forEach(function (value) {
          // sublocality (neighborhood/suburb in some regions)
          if (value.types.includes("sublocality") || value.types.includes("sublocality_level_1")) {
            address.suburb = value.long_name;
          }
        });
        place.address_components.forEach(function (value) {
          // postal_town (UK and some European countries)
          if (value.types.includes("postal_town")) {
            address.suburb = value.long_name;
          }
        });
        place.address_components.forEach(function (value) {
          // locality is the most common and preferred city type
          if (value.types.includes("locality")) {
            address.suburb = value.long_name;
          }
        });

        // set state
        place.address_components.forEach(function (value) {
          if (value.types.includes("administrative_area_level_1")) {
            address.state = value.long_name;
          }
        });

        place.address_components.forEach(function (value) {
          if (value.types.includes("postal_code")) {
            address.postcode = value.long_name;
          }
        });

        let region_id = null;
        this.state.regions.forEach((v) => {
          if (v.name === address.state) {
            region_id = v.id;
          }
        });
        const country_id = "AU";
        this.props.change("address", place.formatted_address);
        this.props.change("street_address", address.street_address);
        this.props.change("suburb", address.suburb);
        this.props.change("state", region_id);
        this.props.change("country", country_id);
        this.props.change("postcode", address.postcode);

        this.props.clearValidation();
      } else {
        // show inputs
      }
    });
  };

  renderInput = ({
    input,
    label,
    type,
    defaultValue,
    readonly,
    id,
    addressCallback,
  }) => {
    return (
      <div>
        <input
          {...input}
          id={id}
          type={type}
          placeholder={label}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          ref={addressCallback}
        />
      </div>
    );
  };

  renderSelect = ({ input, isCountries, isRegions, defaultValue }) => {
    let options = null;
    if (isCountries) {
      options = (
        <option key="AU" value="AU" defaultValue={defaultValue}>
          Australia
        </option>
      );
    } else if (isRegions) {
      options = [<option key="enter_state">Enter State</option>];
      let region_options = [];
      if (this.state) {
        region_options = this.state.regions.map((region) => {
          return (
            <option key={region.id} value={region.id}>
              {region.name}
            </option>
          );
        });
      }
      options = options.concat(region_options);
    }

    return (
      <div className="select-wrapper">
        <select {...input} defaultValue={defaultValue}>
          {options}
        </select>
      </div>
    );
  };

  handleSubmit = (formValues) => {
    console.log(formValues);

    const country_id = "AU";
    this.props.change("country", country_id);

    let input_validation = {};
    let show_address_fields = false;

    // mobile
    if (!formValues.mobile || formValues.mobile.trim().length === 0) {
      input_validation.mobile = ["Please enter a valid mobile"];
    }
    // fullname
    if (
      !formValues.fullname ||
      formValues.fullname.trim().length === 0 ||
      formValues.fullname.trim().split(" ").length < 2
    ) {
      input_validation.fullname = ["Please enter your full name"];
    }
    // street_address
    if (
      !formValues.street_address ||
      formValues.street_address.trim().length === 0
    ) {
      input_validation.street_address = ["Missing street address"];
      show_address_fields = true;
    }
    // suburb
    if (!formValues.suburb || formValues.suburb.trim().length === 0) {
      input_validation.suburb = ["Missing suburb"];
      show_address_fields = true;
    }
    // state
    if (
      !formValues.state ||
      formValues.state.trim().length === 0 ||
      formValues.state === "Enter State"
    ) {
      input_validation.state = ["Missing state"];
      show_address_fields = true;
    }
    // country
    if (!formValues.country || formValues.country.trim().length === 0) {
      input_validation.country = ["Missing country"];
      show_address_fields = true;
    }
    // postcode
    if (!formValues.postcode || formValues.postcode.trim().length === 0) {
      input_validation.postcode = ["Missing postcode"];
      show_address_fields = true;
    }
    console.log("input_validation", input_validation);

    if (Object.keys(input_validation).length > 0) {
      if (show_address_fields) {
        this.setState({ show_address_fields: true });
      }
      this.props.inputValidation(input_validation);
      if (this.addressInput) {
        this.addressInput.focus();
      }
    } else {
      console.log("VALID!!!");
      this.props.clearValidation();
      // setup data for ajax

      const names = formValues.fullname.trim().split(" ");
      const firstname = names[0];
      names.splice(0, 1);
      const lastname = names.join(" ");

      const region = this.state.regions.filter((v) => {
        return v.id == formValues.state;
      });
      console.log("region", region);

      let region_data = {};
      if (region.length > 0) {
        region_data = region[0];
      } else {
        console.log("Error getting region");
        return;
      }

      console.log("region_data", region_data);

      const new_shipping_address_data = {
        region: {
          region_code: region_data.code,
          region: region_data.name,
          region_id: region_data.id,
        },
        region_id: region_data.id,
        country_id: formValues.country,
        street: [formValues.street_address],
        telephone: formValues.mobile,
        postcode: formValues.postcode,
        city: formValues.suburb,
        firstname: firstname,
        lastname: lastname,
      };

      this.props.setLoader(true, "Saving Address...");

      // Save address to localStorage
      const existingAddresses = JSON.parse(localStorage.getItem("shippingAddresses") || "[]");
      const addressWithId = {
        ...new_shipping_address_data,
        id: `addr_${Date.now()}`,
      };
      existingAddresses.push(addressWithId);
      localStorage.setItem("shippingAddresses", JSON.stringify(existingAddresses));

      // Update customer profile via Amplify
      this.props.updateCustomer(
        {
          firstname: firstname,
          lastname: lastname,
          email: localStorage.email || '',
          addresses: [addressWithId],
        },
        () => {
          this.setState({ savedShippingAddress: true });
          this.props.setLoader(false, null);
          history.push('/account/addressinformation');
        }
      );
    }
  };

  render() {
    let mobileMessage = this.props.input_validation.mobile.map((message) => (
      <div key={message} className="input-validation">
        {message}
      </div>
    ));
    let fullnameMessage = this.props.input_validation.fullname.map(
      (message) => (
        <div key={message} className="input-validation">
          {message}
        </div>
      )
    );
    let addressMessage = this.props.input_validation.address.map((message) => (
      <div key={message} className="input-validation">
        {message}
      </div>
    ));
    let streetAddressMessage = this.props.input_validation.street_address.map(
      (message) => (
        <div key={message} className="input-validation">
          {message}
        </div>
      )
    );
    let suburbMessage = this.props.input_validation.suburb.map((message) => (
      <div key={message} className="input-validation">
        {message}
      </div>
    ));
    let stateMessage = this.props.input_validation.state.map((message) => (
      <div key={message} className="input-validation">
        {message}
      </div>
    ));
    let countryMessage = this.props.input_validation.country.map((message) => (
      <div key={message} className="input-validation">
        {message}
      </div>
    ));
    let postcodeMessage = this.props.input_validation.postcode.map(
      (message) => (
        <div key={message} className="input-validation">
          {message}
        </div>
      )
    );

    return (
      <div id="page-account-add-address">
        <AccountNav />
        <div id="account-content">
          <form
            className="form"
            onSubmit={this.props.handleSubmit(this.handleSubmit)}
          >
            <div className="shipping-address-right add-shipping-address-container">
              <div id="checkout-shipping-form">
                <div id="add-new-address-heading">Add New Address</div>
                <div className="input-box">
                  <Field
                    name="fullname"
                    component={this.renderInput}
                    label="Fullname"
                    type="text"
                  />
                  {fullnameMessage}
                </div>
                <div className="input-box">
                  <Field
                    name="mobile"
                    component={this.renderInput}
                    label="Mobile"
                    type="text"
                    // readonly={true}
                  />
                  {mobileMessage}
                </div>
                <div className="input-box">
                  <Field
                    name="address"
                    component={this.renderInput}
                    label="Type Address..."
                    type="text"
                    id="google-places-input"
                    onKeyPress={(e) => {
                      console.log("in here7878");
                      if (e.key === "Enter") e.preventDefault();
                    }}
                    addressCallback={(input) => {
                      this.addressInput = input;
                    }}
                  />
                  {addressMessage}
                </div>
                {this.state.show_address_fields && (
                  <div>
                    <div className="input-box">
                      <Field
                        name="street_address"
                        component={this.renderInput}
                        label="Enter Street Address"
                        type="text"
                      />
                      {streetAddressMessage}
                    </div>
                    <div className="input-box">
                      <Field
                        name="suburb"
                        component={this.renderInput}
                        label="Enter Suburb"
                        type="text"
                      />
                      {suburbMessage}
                    </div>
                    <div className="input-box">
                      <Field
                        name="state"
                        component={this.renderSelect}
                        label="Enter State"
                        type="text"
                        isRegions={true}
                        value="569"
                      />
                      {stateMessage}
                    </div>
                    <div className="input-box">
                      <Field
                        name="country"
                        component={this.renderSelect}
                        label="Enter Country"
                        type="text"
                        isCountries={true}
                        defaultValue="AU"
                      />
                      {countryMessage}
                    </div>
                    <div className="input-box">
                      <Field
                        name="postcode"
                        component={this.renderInput}
                        label="Enter Postcode"
                        type="text"
                      />
                      {postcodeMessage}
                    </div>
                  </div>
                )}
                <button id="add-shipping-address-button" type="submit">
                  Save Address
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    input_validation: state.input_validation,
    auth: state.auth,
  };
};

const accountAddAddressPage = reduxForm({
  form: "add-address",
})(AccountAddAddressPage);

export default requireAuth(
  connect(mapStateToProps, { clearValidation, inputValidation, updateCustomer, setLoader })(accountAddAddressPage)
);
